export default __webpack_public_path__ + "static/media/budgettracker.845871f4.png";